/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Contexte dossier d'un item du flux global / des notifications. Absent si le dossier a ete supprime (prevoir le cas) et jamais envoye dans l'historique d'un dossier (timeline) — la presence du champ pilote l'affichage des chips, aucune autre condition. Tous les champs sauf riskId sont omis si null.
 * 
 * @export
 * @interface ActivityContextDto
 */
export interface ActivityContextDto {
    /**
     * Identifiant du risque assure (dossier)
     * @type {string}
     * @memberof ActivityContextDto
     */
    riskId: string;
    /**
     * Identifiant humain du dossier (ex EMP-20260713-0ea10da6)
     * @type {string}
     * @memberof ActivityContextDto
     */
    riskIdentifier?: string | null;
    /**
     * Code de branche du dossier (EMP, CBNO...)
     * @type {string}
     * @memberof ActivityContextDto
     */
    branchCode?: string | null;
    /**
     * Identifiant du client principal du dossier
     * @type {string}
     * @memberof ActivityContextDto
     */
    clientId?: string | null;
    /**
     * Nom complet du client principal
     * @type {string}
     * @memberof ActivityContextDto
     */
    clientName?: string | null;
    /**
     * Identifiant du contrat — absent si pas de contrat
     * @type {string}
     * @memberof ActivityContextDto
     */
    contractId?: string | null;
    /**
     * Identifiant humain du contrat — absent si pas de contrat
     * @type {string}
     * @memberof ActivityContextDto
     */
    contractIdentifier?: string | null;
    /**
     * Projet d'emprunt (espace emprunteur) — absent hors branche EMP
     * @type {string}
     * @memberof ActivityContextDto
     */
    borrowerProjectId?: string | null;
}

/**
 * Check if a given object implements the ActivityContextDto interface.
 */
export function instanceOfActivityContextDto(value: object): value is ActivityContextDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    return true;
}

export function ActivityContextDtoFromJSON(json: any): ActivityContextDto {
    return ActivityContextDtoFromJSONTyped(json, false);
}

export function ActivityContextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityContextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'riskIdentifier': json['riskIdentifier'] == null ? undefined : json['riskIdentifier'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'contractId': json['contractId'] == null ? undefined : json['contractId'],
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : json['contractIdentifier'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
    };
}

export function ActivityContextDtoToJSON(json: any): ActivityContextDto {
    return ActivityContextDtoToJSONTyped(json, false);
}

export function ActivityContextDtoToJSONTyped(value?: ActivityContextDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'riskIdentifier': value['riskIdentifier'],
        'branchCode': value['branchCode'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'contractId': value['contractId'],
        'contractIdentifier': value['contractIdentifier'],
        'borrowerProjectId': value['borrowerProjectId'],
    };
}

